export default String.raw`
<div class="cart-recommendations-list cart-recommended-products-list-js swiper">
    <div class="cart-recommendations-list__wrapper swiper-wrapper">
        {% include 'partials/cart/products-partials/recommended-item.html' for products, isDiscountItem: isDiscountItem -%}
    </div>
    <div class="cart-recommendations-item__slider-prev">
        <svg>
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
        </svg>
    </div>
    <div class="cart-recommendations-item__slider-next">
        <svg>
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use>
        </svg>
    </div>
</div>

<script>
    if (typeof window.initRecommendedSlider == 'function') {
        window.initRecommendedSlider();
    }
</script>
`